import { registerEntityFieldConfig } from 'components/Entities/EntityDetailsTab/entityFieldConfig';

import { EntityModules } from 'core/constants';

import { formatLibraryId } from 'utils/formatters/libraryId';

import { HAZARD_FIELD } from './constants';
import { HAZARD_RECORD_REQUIRED_KEYS } from './utils';

registerEntityFieldConfig(EntityModules.Hazards, {
  renderers: {
    [HAZARD_FIELD.id]: (value) => formatLibraryId(EntityModules.Hazards, value as number | null),
  },
  rules: {
    isRequired: (fieldKey) => HAZARD_RECORD_REQUIRED_KEYS.has(fieldKey),
  },
});
